import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "simplifyColors",
  standalone: true,
})
export class SimplifyColorsPipe implements PipeTransform {
  transform(colors: any[]): any[] {
    return colors.map((color) => ({
      key: "var(--" + color.key + ")",
      name: color.data.name,
      value: color.data.value,
    }));
  }
}
